var _rect, _rect2, _rect3, _path, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 164,
    viewBox: "0 0 199 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.8848,
    y: 149.013,
    width: 45.3294,
    height: 16.9424,
    rx: 8.47122,
    transform: "rotate(-30 33.8848 149.013)",
    fill: "#E6E6E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0684,
    y: 103.474,
    width: 22.5649,
    height: 16.9237,
    rx: 8.46183,
    transform: "rotate(-30 11.0684 103.474)",
    fill: "#E6E6E6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 141.77,
    y: 8.47125,
    width: 16.9424,
    height: 16.9424,
    rx: 8.47122,
    transform: "rotate(-30 141.77 8.47125)",
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0943 65.4416C39.0425 67.7809 37.6543 72.9618 39.9936 77.0135C42.328 81.0568 47.4921 82.4476 51.5401 80.1288L77.6068 65.0792C81.6585 62.7399 86.8394 64.1281 89.1787 68.1799C91.5179 72.2316 90.1297 77.4125 86.078 79.7518L64.975 91.9355C64.9808 91.9322 64.9865 91.9289 64.9923 91.9256L133.4 52.4307C133.408 52.4256 133.417 52.4205 133.426 52.4154L132.136 53.16C128.084 55.4993 122.904 54.111 120.564 50.0593C118.225 46.0076 119.613 40.8267 123.665 38.4874L129.917 34.878C133.943 32.5299 135.318 27.3659 132.985 23.325C130.645 19.2733 125.465 17.8851 121.413 20.2244L43.0943 65.4416ZM92.412 115.222C88.3736 117.566 86.9926 122.738 89.3285 126.784C91.6678 130.836 96.8487 132.224 100.9 129.884L163.769 93.5873C167.821 91.248 169.209 86.0671 166.87 82.0154C164.53 77.9636 159.35 76.5754 155.298 78.9147L134.424 90.9664C134.532 90.9033 134.639 90.8383 134.744 90.7712C130.747 92.8432 125.788 91.4214 123.514 87.483C121.241 83.5459 122.488 78.5425 126.278 76.1163C126.163 76.1759 126.049 76.2384 125.935 76.3038L84.8751 100.01C88.9204 97.705 94.0731 99.0977 96.4041 103.135C98.7434 107.187 97.3552 112.368 93.3034 114.707L81.8927 121.295C81.9068 121.287 81.9209 121.279 81.935 121.271L92.412 115.222ZM84.8545 100.022C84.8471 100.026 84.8396 100.03 84.8322 100.034L58.38 115.307C54.3316 117.628 49.1654 116.237 46.8304 112.193C44.4911 108.141 45.8794 102.961 49.9311 100.621L154.291 40.369C158.343 38.0297 163.524 39.418 165.863 43.4697C168.202 47.5214 166.814 52.7023 162.762 55.0416L155.607 59.1724C155.595 59.1793 155.583 59.1861 155.571 59.1931L126.615 75.9111C126.603 75.918 126.591 75.9249 126.579 75.9319L84.8545 100.022Z",
    fill: "#E6E6E6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 189.922,
    cy: 99.8496,
    r: 4.15044,
    stroke: "#E6E6E6",
    strokeWidth: 2.60547
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.3425,
    cy: 43.6254,
    r: 3.0222,
    stroke: "#E6E6E6",
    strokeWidth: 2.60547
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.4558,
    cy: 150.809,
    r: 3.0222,
    stroke: "#E6E6E6",
    strokeWidth: 2.60547
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120.533,
    y: 4.32495,
    width: 10.5303,
    height: 1.88041,
    rx: 0.940203,
    fill: "#E6E6E6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 126.738,
    width: 10.5303,
    height: 1.88041,
    rx: 0.940203,
    transform: "rotate(90 126.738 0)",
    fill: "#E6E6E6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 157.014,
    y: 125.329,
    width: 7.89771,
    height: 1.88041,
    rx: 0.940203,
    fill: "#E6E6E6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 161.902,
    y: 122.414,
    width: 7.89771,
    height: 1.88041,
    rx: 0.940203,
    transform: "rotate(90 161.902 122.414)",
    fill: "#E6E6E6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7.14648,
    y: 87.1569,
    width: 7.89771,
    height: 1.88041,
    rx: 0.940203,
    fill: "#E6E6E6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0352,
    y: 84.2422,
    width: 7.89771,
    height: 1.88041,
    rx: 0.940203,
    transform: "rotate(90 12.0352 84.2422)",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.391 40.7799C102.289 37.1265 97.0303 37.1265 94.9284 40.7799L52.0651 115.286C49.9686 118.93 52.5846 123.499 56.7962 123.499H142.523C146.735 123.499 149.351 118.93 147.254 115.286L104.391 40.7799Z",
    fill: "white",
    stroke: "#AFAFAF",
    strokeWidth: 2.60547
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.5293 122.196H142.523C145.725 122.196 147.726 118.718 146.125 115.935L103.262 41.4296C102.436 39.9951 100.973 39.3001 99.5293 39.3446V122.196Z",
    fill: "#ECECEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.579 94.5758L96.2692 94.5758L96.2692 68.2633L102.579 68.2633L102.579 94.5758ZM99.399 98.9119C100.543 98.9119 101.502 99.2569 102.276 99.9467C103.05 100.669 103.438 101.556 103.438 102.608C103.438 103.659 103.05 104.529 102.276 105.219C101.502 105.942 100.543 106.303 99.399 106.303C98.2548 106.303 97.2957 105.958 96.5216 105.268C95.7476 104.611 95.3605 103.774 95.3605 102.755C95.3605 101.671 95.7476 100.752 96.5216 99.996C97.262 99.2733 98.2211 98.9119 99.399 98.9119Z",
    fill: "#AFAFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.4de95583.svg";
export { ForwardRef as ReactComponent };